import UpdateFacility from './UpdateFacility';

export default UpdateFacility;